import React from 'react';
import { Tooltip } from 'antd';
import { usePermissionCheck } from './usePermissionCheck';

export const PermissionViewable = ({ permissionCheck, permissionMessage, tooltipMessage, children, hideTooltip = true }) => {
  const { permissionDisabled } = usePermissionCheck(permissionCheck);
  
  const finalTooltipMessage = tooltipMessage || permissionMessage || "You don't have permission to view this content";
  
  // If no permission, render the permission message with tooltip
  if (permissionDisabled) {
    return (
      <Tooltip title={hideTooltip ? "" : finalTooltipMessage}>
        <div>{permissionMessage}</div>
      </Tooltip>
    );
  }
  
  // If has permission, render the children
  return <>{children}</>;
};

export default PermissionViewable; 